import loadingButtonClasses from "@mui/lab/LoadingButton/loadingButtonClasses";
import buttonClasses from "@mui/material/Button/buttonClasses";
import { resolve } from "./utils";
export const button = (variant, type, dt, append, variantAdjust) => {
    const border = (obj, state) => {
        if (Object.prototype.hasOwnProperty.call(obj, state)) {
            return obj[state];
        }
        return "";
    };
    const shadowType = type.toString() === "inverted" ? ["neutralInverted"] : type;
    const backgroundColor = resolve(variant.color.background, type);
    const borderColor = resolve(variant.color.border, type);
    const textColor = resolve(variant.color.text, type);
    const bg = backgroundColor.default;
    const bgHover = backgroundColor.hover;
    const bgPressed = backgroundColor.pressed;
    const bgFocus = backgroundColor.focus;
    const bgDisabled = backgroundColor.disabled;
    let style = {
        borderColor: borderColor.default,
        color: textColor.default,
        backgroundColor: bg,
        ".PixelIcon": {
            backgroundColor: textColor.default,
        },
        "&:hover, &:hover::after, &:is(.Pxl-demo-hover, [data-demostate=hover]), &:is(.Pxl-demo-hover, [data-demostate=hover])::after": Object.assign(Object.assign({}, (variantAdjust !== "text" && {
            borderColor: border(borderColor, "hover"),
            borderWidth: dt.button.shape.border,
        })), { color: textColor.hover || textColor.default, backgroundColor: bgHover, ".PixelIcon": {
                backgroundColor: textColor.hover || textColor.default,
            } }),
        "&:focus-visible, &:focus-visible::after, &:is(.Pxl-demo-focus, [data-demostate=focus]), &:is(.Pxl-demo-focus, [data-demostate=focus])::after": Object.assign(Object.assign({}, (variantAdjust !== "text" && {
            borderColor: border(borderColor, "focus"),
        })), { color: textColor.focus || textColor.default, backgroundColor: bgFocus, boxShadow: resolve(dt.state.focus, shadowType), ".PixelIcon": {
                backgroundColor: textColor.focus || textColor.default,
            } }),
        "&:active, &:active::after, &:is(.Pxl-demo-active, [data-demostate=active]), &:is(.Pxl-demo-active, [data-demostate=active])::after": Object.assign(Object.assign({}, (variantAdjust !== "text" && {
            borderColor: border(borderColor, "pressed"),
        })), { color: textColor.pressed || textColor.default, backgroundColor: bgPressed, ".PixelIcon": {
                backgroundColor: textColor.pressed || textColor.default,
            } }),
        [`&[disabled], &.disabled, &.${buttonClasses.disabled}`]: Object.assign(Object.assign({}, (variantAdjust !== "text" && {
            borderColor: border(borderColor, "disabled"),
        })), { color: textColor.disabled, backgroundColor: bgDisabled, boxShadow: "none", [`.${loadingButtonClasses.loadingIndicator}`]: {
                color: textColor.disabled,
            }, svg: {
                fill: textColor.disabled,
            }, ".PixelIcon": {
                backgroundColor: textColor.disabled,
            } }),
    };
    if (append) {
        style = Object.assign(Object.assign({}, style), append);
    }
    return style;
};
export const buttonIcon = (size) => {
    return {
        width: size,
        height: size,
        ".PixelIcon": {
            width: size,
            height: size,
        },
    };
};
